import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { getAuthOptions } from '../../lib/Auth0';
import { isBridgAdmin } from '../../lib/Helpers';
import { authorization, getLaunchDarklyContext, setFeatureFlags } from '../../modules/App';

const Authentication = (props) => {
  const { children } = props;
  const { isLoading, isAuthenticated, user, getAccessTokenSilently, logout } = useAuth0();

  const dispatch = useDispatch();
  const account = useSelector((state) => state.app.account);
  const brand = useSelector((state) => state.app.brand);
  const ldClient = useLDClient();
  const history = useHistory();

  useEffect(() => {
    getAuthOptions({ getAccessTokenSilently });
  }, [getAccessTokenSilently]);

  // Update feature flags in store when any LaunchDarkly flags change
  useEffect(() => {
    ldClient.on('change', () => {
      dispatch(setFeatureFlags(ldClient.allFlags()));
    });
  }, [dispatch, ldClient]);

  // User authorization
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      dispatch(authorization({ user, url: window.location.href }));
    } else if (!isLoading && !isAuthenticated) {
      const targetUrl = window.location.href.split('/').splice(3).join('/');
      if (window.location.pathname === '/403') {
        history.push(targetUrl);
      } else {
        history.push('/login', targetUrl);
      }
    }
  }, [isLoading, isAuthenticated, dispatch, user, history]);

  // Re-identify with LaunchDarkly anytime user, account, or brand changes
  useEffect(() => {
    if (!isLoading && isAuthenticated && ldClient) {
      ldClient.identify(getLaunchDarklyContext({ account, brand, user }));
    }
  }, [account, brand, isAuthenticated, isLoading, ldClient, user]);

  if (isLoading) return null;

  return <>{React.cloneElement(children, { isAuthenticated, isBridgAdmin: isBridgAdmin(user), logout, getAccessTokenSilently })}</>;
};

export default Authentication;
